window.OneclickCart = (function () {

	var dom = {};
	var baseSums = {};
    var items = {};

    var isSending = false;
    var sendingOriginalId = undefined, sendingEventId = undefined;

    function setSendingIds(oid, eid) {
        oid = Number(oid);
        if (oid != NaN)
            sendingOriginalId = oid;

        eid = Number(eid);
        if (eid != NaN)
            sendingEventId = eid;
    }

    function clearSendingIds() {
        sendingOriginalId = undefined;
        sendingEventId = undefined;
    }

    function cancelLiveBet() {
        var item = OneclickCart.items[sendingOriginalId];
        if (item.isLiveBetWaiting && typeof (item.liveBetTimeout) !== 'undefined') {
            clearTimeout(item.liveBetTimeout);

            item.isLiveBetWaiting = false;
            item.setErrorMessage(Localization.getString('BettingCart.CoefChanged', 'Коэффициент был изменен'));
            item.setRequestStatus('error');

            item.timeout = setTimeout(function () {
                item.remove();
            }, 10000);

            BettingCart.visual.hideLoader();
            OneclickCart.isSending = false;
            clearSendingIds();
        }
    }

	var bindUIActions = function () {
        dom.sumInput.on('input change', function () {
            const filteredVal = $(this).val().replace(/\D/g, ''); 
            $(this).val((parseInt(filteredVal) === 0 || !filteredVal) ? '' : app.numberToString(filteredVal));

            if (OneclickCart.validate() === false) {
                dom.sumInput.addClass('error');
                OneclickCart.showErrors([100]);
            } else {
                BettingCart.save();
            }
		});

		dom.betSumButton.on('click', function () {
			var button = $(this);
			var sum = button.data('sum');

			if (sum) {
				dom.sumInput.val(sum).trigger('change');

				button.addClass('active');
				setTimeout(function () {
					button.removeClass('active');
				}, 500);
			}
		});

		dom.addButton.on('click', function () {
			var add = $(this).data('add');
			var baseSum = parseInt(dom.sumInput.val().replace(/\s+/g, '')) || 0;

			if (add) {
				dom.sumInput.val(baseSum + add).trigger('change');
			}
		});

		dom.automaxSwitcher.on('click', function () {
			BettingCart.save();
		});
	};    

	return {
		load: function (data) {                            
				dom.betSumButton = $('[js-node="oneclick-cart__bet-sum"]');
				dom.addButton = $('[js-node="oneclick-cart__add-to-sum"]');
				dom.sumInput = $('[js-node="one-click__sum-input"]');
				dom.automaxSwitcher = $('[js-node="oneclick-cart__automax-switcher"]');
				dom.errorsContainer = $('[js-node="oneclick-cart__errors"]');

				dom.betSumButton.each(function () {
					var container = $(this);
					var val = container.attr('data-sum');

					baseSums[val] = container;
				});

				bindUIActions();

				if (data) {
					if (data.hasOwnProperty('betSum'))
						dom.sumInput.val(app.numberToString(data.betSum));
					if (data.hasOwnProperty('automax'))
						dom.automaxSwitcher.prop('checked', data.automax);
				}

				if (dom.sumInput.val() == '') {
					if (window.globalAppSettings.defaultBet) {                		
						dom.sumInput.val(window.globalAppSettings.defaultBetSum || '');
					}
				}									

				dom.sumInput.trigger('change');            
		},
		getData: function() {
			var self = this;

			return {
				betSum: self.getSum(),
				automax: self.getAutomaxValue()
			};
		},
		getSum: function () {
			return parseInt(dom.sumInput.val().replace(/\s+/g, ''));
		},
		clearSum: function () {
			if (dom.hasOwnProperty('sumInput')) {
				dom.sumInput.val('');
				BettingCart.save();
			}
		},
		getItems: function () {
			return items;
        },
        getItem: function (oid) {
            return items[oid];
        },
        checkCoefForWaitingLiveBet: function (oid) {
            if (Number(oid) === sendingOriginalId)
                cancelLiveBet();
        },
        checkEventForWaitingLiveBet: function (eid) {
            if (Number(eid) === sendingEventId)
                cancelLiveBet();
        },
		getAutomaxValue: function () {
			return dom.automaxSwitcher.prop('checked');
		},
		validate: function () {
			if (dom.sumInput.val() === '') {
				return false;
			} else {
				dom.sumInput.removeClass('error');
				OneclickCart.hideErrors();
			}

			return true;
		},
		showErrors: function (errors) {
            var errorsTexts = {
                100: Localization.getString('BettingCart.AmountRequired', 'Необходимо указать сумму')                
			};
			errors = errors || [];

			if (errors.length > 0) {
				var text = '';
                dom.errorsContainer.attr('bb-tool', text);

				for (var i = 0; i < errors.length; i++) {
					text += errorsTexts[errors[i]] || errors[i];
					if (i != errors.length) text += '<br />';
				}

                dom.errorsContainer.attr('bb-tool', text);
				
				if (dom.errorsContainer.filter(':visible').length !== 0) 
					dom.errorsContainer.animate({ opacity: 0.1 }, 100).animate({ opacity: 1 }, 100);
				else
					dom.errorsContainer.show();

				dom.sumInput.addClass('m-error');
			}
		},
		hideErrors: function () {
			dom.errorsContainer.hide();
			dom.sumInput.removeClass('m-error');
        },        
		addItem: function (data) {
			if (data.oId) {
                var item = {
                    actualData: {
                        oId: data.oId,
                        aId: data.aId,
                        val: data.val,
                        eId: data.eId
                    },
                    loadActualCoefValue: function (callback) {
                        var self = this;
                        Ajax.postJson("/BettingCart/GetActualCoefs", {
                            data: {
                                coefs: [{
                                    coefid: self.actualData.oId,
                                    eventid: self.actualData.eId
                                }]
                            },
                            success: function (resp) {
                                if (Array.isArray(resp) && resp.length == 1) {
                                    let actual = resp[0];
                                    if (parseInt(actual.oid) === parseInt(self.actualData.oId)) {

                                        self.actualData.rTitle = actual.n;
                                        if (actual.hasOwnProperty('ht')) {
                                            self.actualData.eTitle = (actual.hasOwnProperty('at')) ? (actual.ht + ' — ' + actual.at) : actual.ht;
                                        }

                                        callback();
                                    }
                                }
                            }
                        });
                    },
					create: function () {
						var self = this;

						self.container = $('<div/>', {
							'class': 'b-cart-one-click-item'
						});
                        self.container.attr('original-id', self.actualData.oId);
						var html = [
								'<div class="b-cart-one-click-item__header">',
                                    '<div class="b-cart-one-click-item__title">' + self.actualData.eTitle + '</div>',
                                    '<div class="b-cart-one-click-item__remove js-cart-one-click-item-remove">' + Utils.svgHtml('close', 'modal__close-icon') + '</div>',
								'</div>',
								'<div class="b-cart-one-click-item__body">',
									'<div class="b-cart-one-click-item__row">',
										'<div class="b-cart-one-click-item__label">' + self.actualData.rTitle + '</div>',
										'<div class="b-cart-one-click-item__value">' + self.actualData.val + '</div>',
									'</div>',
									'<div class="b-cart-one-click-item__row">',
                            '<div class="b-cart-one-click-item__label">' + Localization.getString('Shared.Amount', 'Сумма') + '</div>',
                            '<div class="b-cart-one-click-item__value"><span class="js-cart-one-click-item__value-bet-sum">' + data.betSum + '</span> <span class="b-cart-one-click-item__value-currency">' + window.globalAppSettings.currentUser.defaultBalance.currencySymbol + '</span></div>',
									'</div>',
									'<div class="b-cart-one-click-item__row">',
                            '<div class="b-cart-one-click-item__label">' + Localization.getString('Profile.BetStatus') +'</div>',
										'<div class="b-cart-one-click-item__value b-cart-one-click-item__status">',
                            '<div class="b-cart-one-click-item__status-item ok"><div class="b-cart-one-click-item__status-icon"></div> ' + Localization.getString('BettingCart.Accepted','Принято') + '</div>',
                                            '<div class="b-cart-one-click-item__status-item need-confirmation">',
                                                '<div style="margin:0 10px">' + Utils.svgHtml('wait', 'icon-status-waiting-for-confirm') + '</div>',
                            '<div style="flex-basis: 130px; flex-shrink: 1; flex-grow: 0;">' + Localization.getString('Bets.BetConfirmation') +'</div>',
                                            '</div>',
                            '<div class="b-cart-one-click-item__status-item error"><div class="cart-oneclick__error-wrapper js-cart-one-click-error-message-tooltip" bb-tool="tooltip" bb-tool-type="error"><div class="cart-oneclick__error-icon icon-error">i</div> ' + Localization.getString('Shared.Error','Ошибка') +'</div></div>',
                            '<div class="b-cart-one-click-item__status-item loading active"><div class="betting-cart__loader-spiner-wrapper m-one-click-item"><div class="betting-cart__loader-spiner-container"><div class="betting-cart__loader-spiner-speeding-wheel"></div></div></div> ' + Localization.getString('BettingCart.Waiting','Ожидание') +'</div>',
										'</div>',
									'</div>',
								'</div>',
						].join('\n');

						self.container.append(html);

						self.container.find('.js-cart-one-click-item-remove').on('click', function () {
							self.remove();
						});
					},
					setResultMoneyValue: function (value) {
						var self = this;

						self.container.find('.js-cart-one-click-item__value-bet-sum').html(value);
					},
					draw: function () {
                        var self = this;

                        if (globalAppSettings.isMobileDevice && !globalAppSettings.isMobileDeviceInDesktopMode) {
                            $('body').append(self.container);

                            self.container.css({
                                opacity: 0,                                
                                bottom: '-100px'
                            }).animate({
                                opacity: 1,
                                bottom: 0
                            }, 200);
                        } else {
                            $('[js-node="betting-cart"]').append(self.container);

                            self.container.css({
                                opacity: 0,
                                position: 'relative',
                                top: '100px'
                            }).animate({
                                opacity: 1,
                                top: 0
                            }, 200);
                        }
					},
					remove: function () {
						var self = this;

						if (self.timeout)
							clearTimeout(self.timeout);

						self.container.animate({
							left: self.container.width(),
							opacity: 0
						}, 200, function () {
							self.container.remove();
						});

						if (items[data.oId]) delete items[data.oId];
						
						if (BettingCart.isOneClick())
							BettingCart.Highlighting.deactivate.allScopes(data.oId);
					},
					setRequestStatus: function (status) {
						var self = this;
						status = status || 'loading';
						self.container.find('.b-cart-one-click-item__status-item').removeClass('active');

						switch (status) {
							case 'ok':
								self.container.find('.b-cart-one-click-item__status-item.ok').addClass('active');
								break;
							case 'error':
								self.container.find('.b-cart-one-click-item__status-item.error').addClass('active');
                                break;
                            case 'need-confirmation':
                                self.container.find('.b-cart-one-click-item__status-item.need-confirmation').addClass('active');
                                break;
							case 'loading':
							default:
								self.container.find('.b-cart-one-click-item__status-item.loading').addClass('active');
								break;
						};
					},
                    setErrorMessage: function (message) {
                        console.log(message)
                        this.container.find('.js-cart-one-click-error-message-tooltip').attr('bb-tool', message);
					}
				};
                item.isLiveBetWaiting = false;
                item.loadActualCoefValue(function () {
                    item.create();
                    item.draw();
                });

				items[data.oId] = item;
			}
		},
        items: items,
        sendToServer: function (sendData) {
            Ajax.postJson('/BettingCart/SendOneClick', {
                data: {
                    cartData: JSON.stringify(sendData),
                    duplicateToken: app.generateGUID() + ':' + Date.now()       
                },
                success: function (resp) {
                    //CL-663 -----------------------
                    BettingCart.visual.hideLoader();
                    OneclickCart.isSending = false;
                    clearSendingIds();
                    //---------------------------------

                    if (!OneclickCart.items.hasOwnProperty(resp.originalId)) {
                        return;
                    }

                    OneclickCart.items[resp.originalId].isLiveBetWaiting = false;

                    if (resp.isSuccessful === false) {
                        OneclickCart.items[resp.originalId].setErrorMessage(resp.errorMessage);
                        OneclickCart.items[resp.originalId].setRequestStatus('error');
                    } else {
                        OneclickCart.items[resp.originalId].setResultMoneyValue(resp.resultMoneyValue);
                        var betStatus = (resp.needConfirmation) ? 'need-confirmation' : 'ok';
                        OneclickCart.items[resp.originalId].setRequestStatus(betStatus);
                    }

                    if (OneclickCart.items[resp.originalId]) {
                        OneclickCart.items[resp.originalId].timeout = setTimeout(function () {
                            OneclickCart.items[resp.originalId].remove();
                        }, 10000);
                    }
                    //BettingCart.deactivate(data.oId);
                }
            });
        },
        sendData: function (data) {
            if (!globalAppSettings.currentUser.bettingCart['one-click-send-button'].IsEnabled) return;
            
			if (!OneclickCart.validate()) {
				//BettingCart.deactivate(data.oId);
				dom.sumInput.addClass('error');
				OneclickCart.showErrors([100]);
				return false;
			}

			if (OneclickCart.isSending)
				return false;

			data.betSum = OneclickCart.getSum();
            data.automax = OneclickCart.getAutomaxValue() ? true : false;

			//CL-663 -----------------------
			BettingCart.visual.showLoader();
            OneclickCart.isSending = true;
            setSendingIds(data.oId, data.eId);
			//---------------------------------

            OneclickCart.addItem(data);             

            var sendData = {
                coef: {
                    eventid: data.eId,
                    coefid: data.aId
                },
                coefVal: data.val,
                moneyVal: data.betSum,
                isAutoMax: data.automax,
                isLive: data.isLive
            };
            OneclickCart.sendToServer(sendData);

			return true;
		},
		isSending: isSending,
		removeItem: function (oid) {
			if (OneclickCart.isSending)
				return false;
			OneclickCart.items[oid].remove();
			return true;
		}
	};
}());